import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj25 = () => {
  return (
    <Layout>
      <SEO
        title="Rock Paper and Scissor"
        description="Awesome python project"
      />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-25">
          <div className="py-1-heading">
            <h1>Rock Paper and Scissor</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/Rock%2C%20Paper%20And%20Scissor_Cheating%20Not%20Allowed"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              We have three entities, Rock, Paper and Scissor.
              <br />
              <br />
              Rock can crush Scissor but get covered by Paper.
              <br />
              Paper can crush Rock but get cut by Scissor.
              <br />
              Scissor can cut Paper but get crush bt Rock.
              <br />
              <br />
              It is a two player game.
              <br />
              <br />
              Lets see who wins !!!
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Loops</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj25
